import React from "react";
import { useNavigate } from "react-router-dom";
import { Pencil } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useApp } from "@/context/AppContext";
import { formatCompact } from "@/lib/currency";

function Row({ label, value, bold, accent, indent }) {
  return (
    <div
      className={`flex items-center justify-between py-3 ${
        indent ? "pl-4" : ""
      } ${bold ? "border-t border-zinc-100" : ""}`}
    >
      <span className={`${bold ? "font-heading font-bold text-zinc-900" : "text-sm text-zinc-500"}`}>
        {label}
      </span>
      <span className={`font-mono font-bold ${accent || "text-zinc-900"}`}>{value}</span>
    </div>
  );
}

export default function Budget() {
  const navigate = useNavigate();
  const { report } = useApp();
  const { base } = report;

  return (
    <div className="px-6 pt-8">
      <h1 className="mb-1 font-heading text-2xl font-extrabold text-zinc-900">Anggaran</h1>
      <p className="mb-6 text-sm text-zinc-400">Ringkasan pendapatan &amp; kewajiban keluarga</p>

      <div className="rounded-3xl border border-zinc-200 bg-white p-5 shield-shadow">
        <p className="mb-1 text-xs font-semibold uppercase tracking-wider text-zinc-400 font-heading">
          Pendapatan
        </p>
        <Row label="Gaji Utama" value={formatCompact(base.coreIncome)} />
        <Row label="Side Income" value={formatCompact(base.sideTotal)} accent="text-emerald-700" />
        <Row label="Total Pendapatan" value={formatCompact(base.totalFamilyIncome)} bold />
      </div>

      <div className="mt-4 rounded-3xl border border-zinc-200 bg-white p-5 shield-shadow">
        <p className="mb-1 text-xs font-semibold uppercase tracking-wider text-zinc-400 font-heading">
          Pengeluaran Wajib
        </p>
        <Row label="Total Cicilan" value={formatCompact(base.totalDebt)} />
        <Row label="Kebutuhan Rutin" value={formatCompact(base.living)} />
        <Row label="Pengeluaran Wajib" value={formatCompact(base.essentialOutflow)} bold />
      </div>

      <div className="mt-4 rounded-3xl border border-zinc-200 bg-white p-5 shield-shadow">
        <Row
          label="Surplus Bulanan"
          value={`${base.monthlyBalance >= 0 ? "" : "-"}${formatCompact(Math.abs(base.monthlyBalance))}`}
          bold
          accent={base.monthlyBalance >= 0 ? "text-emerald-600" : "text-rose-600"}
        />
      </div>

      <Button
        data-testid="budget-edit-btn"
        onClick={() => navigate("/app/profil")}
        variant="outline"
        className="mt-5 h-12 w-full rounded-full border-zinc-300 font-semibold"
      >
        <Pencil className="mr-2 h-4 w-4" />
        Edit Data
      </Button>
    </div>
  );
}
